import React from "react";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import "react-table/react-table.css";

export default ({ data, jobId }) => (
  <ReactTable
    data={data}
    defaultPageSize={20}
    defaultSorted={[
      {
        id: "age",
        desc: true
      }
    ]}
    columns={[
      {
        Header: "Personal Info",
        columns: [
          {
            Header: "Photo",
            accessor: "pic",
            Cell: row => (
              <img src={row.value} className="h3 w3" alt="passport" />
            ),
            width: 90
          },
          {
            Header: "First Name",
            accessor: "firstname",
            width: 100
          },
          {
            Header: "Last Name",
            accessor: "lastname",
            width: 100
          },
          {
            Header: "Age",
            accessor: "age",
            width: 50
          },
          {
            Header: "State",
            accessor: "stateOfOrigin",
            width: 100
          }
        ]
      },
      {
        Header: "Qualifictions",
        columns: [
          {
            Header: "Highest Qualification",
            accessor: "highestQualification"
          },
          {
            Header: "Course",
            accessor: "course"
          },
          {
            Header: "Grade",
            accessor: "grade"
          },
          {
            Header: "Graduation Date",
            accessor: "graduationDate"
          },
          {
            Header: "Experience",
            accessor: "yearsOfExperience",
            width: 90
          }
        ]
      },
      {
        Header: "Contact Detail",
        columns: [
          {
            Header: "Email",
            accessor: "email"
          },
          {
            Header: "Phone",
            accessor: "phonenumber",
            width: 130
          }
        ]
      },
      {
        Header: "Actions",
        columns: [
          {
            Header: "Download CV",
            accessor: "cv",
            Cell: row => (
              <a href={row.value} downlaod="" className="underline blue">
                download cv
              </a>
            ),
            width: 100
          },
          {
            Header: "View",
            accessor: "id",
            Cell: row => (
              <Link
                to={`/office/applicant/view/${row.value}/${jobId}`}
                className="underline blue"
              >
                view more
              </Link>
            ),
            width: 80
          }
        ]
      }
    ]}
  />
);



// WEBPACK FOOTER //
// ./src/components/ApplicantTable.js